import { Button, Checkbox, Spin, Tooltip } from "antd";
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import CommonIcons from "../../../assets/icons";
import useToggle from "../../../hooks/useToggle";
import
{
   setCurrentProvider,
   setDataImages,
   setLoadingProvider,
} from "../../../store/reducers/searchSlice";
import { RootState } from "../../../store/store";
import CommonComponents from "../../Commons";
import NoData from "../../NoData";
import CardSearchResult from "./CardSearchResult";
import ImageInfo from "./ImageInfo";
import
{
   addImagesToCart,
   flyToGeometries,
   flyToGeometry,
   ImageItem,
   mouseLeaveItem,
   mouseMoveItem,
   removeFootprint,
   removeImageFromMap,
   removeImagesFromCart,
   showFootprint,
   showImageOnMap,
} from "./ultis";

import { useMapContext } from "../MapAdapter/core/MapContext";
import LazyLoad from 'react-lazyload'
import LoadingGlobalComp from "../../Commons/Loading";
import InfiniteScroll from "react-infinite-scroll-component";

interface ResultSearchProps
{
   data: any;
   setShowResultSearch: (val: boolean) => void;
   providers: any;
   providerCode: any;
   setProviderCode: (providerCode: any) => void;
   setData: (data: any) => void;
   mapInstance: any;
   handleScroll: (e?: any) => void | any;
   providerId: any;
   loading: boolean;
   setLoading: (val: boolean) => void;
}

export default function ResultSearch({
   data,
   setShowResultSearch,
   providers,
   providerCode,
   setProviderCode,
   setData,
   mapInstance,
   handleScroll,
   providerId,
   loading,
   setLoading,
}: ResultSearchProps)
{
   const dispatch = useDispatch();
   const { t } = useTranslation();
   const { engine } = useMapContext();

   const [selectedImages, setSelectedImages] = useState([]);
   const [selectedView, setSelectedView] = useState<any>(undefined);

   let searchState = useSelector((state: RootState) => state.search);

   let arrProviders = useSelector(
      (state: RootState) => state.appCommonSlice.allProviders,
   );
   const idsImageInCart = useSelector(
      (state: RootState) => state.cartSlice.arrIdImage,
   );

   const layersOnMap = useSelector((state: RootState) => state.layer.layers);

   const layerIds = useMemo(
      () => new Set(layersOnMap.map((l: any) => l.id)),
      [layersOnMap],
   );
   let providerName = arrProviders
      ?.filter((itemF: any) => itemF?.code === providerCode)?.[0]
      ?.name.toLowerCase();

   const isAllFootprintShown =
      selectedImages.length > 0 &&
      selectedImages.every((img: any) => layerIds.has(`footerprint-${img?.id}`));
   const isAllImageShown =
      selectedImages.length > 0 &&
      selectedImages.every((img: any) => layerIds.has(`image-${img?.id}`));
   const isAllInCart =
      selectedImages.length > 0 &&
      selectedImages.every((img: any) => idsImageInCart.includes(img?.id));

   const {
      open: openViewInfo,
      shouldRender: shouldRenderViewInfo,
      toggle: toggleViewInfo,
   } = useToggle();


   const handleChangeProvider = (item: any) =>
   {
      //  @ts-ignore
      if (!searchState[`loading_provider_${item.code}`])
      {
         setSelectedImages([])
         dispatch(setLoadingProvider({ code: item.code, value: true }));
         dispatch(setCurrentProvider(item.code));

         setProviderCode(item?.code);
         //  @ts-ignore
         const data = searchState[`data_images_${item.code}`] ?? [];

         dispatch(setDataImages({
            code: item.code,
            data
         }));
         setData(data);
         dispatch(setLoadingProvider({ code: item.code, value: false }));
      }
   };

   const renderProvider = () =>
   {
      let a = providers?.map((item: any, ind: any) =>
      {
         return (
            <Tooltip title={item?.name}>
               <Spin
                  style={{
                     //  @ts-ignore
                     cursor: !searchState[`loading_provider_${item.code}`]
                        ? "default"
                        : "no-drop",
                  }}
                  //  @ts-ignore
                  spinning={searchState[`loading_provider_${item.code}`]}
                  className="!h-[68px] min-h-[68px] !max-h-[68px]"
               >
                  <div
                     key={ind}
                     className={
                        "h-[68px] w-[68px] min-h-[68px] div-one-center !justify-center !max-h-[68px]  rounded-md " +
                        (providerCode === item?.code ? "active-provider-item" : "")
                     }
                     style={{
                        //  @ts-ignore
                        cursor: !searchState[`loading_provider_${item.id}`]
                           ? "pointer"
                           : "no-drop",
                     }}
                     onClick={() =>
                     {
                        handleChangeProvider(item);
                     }}
                  >
                     <div
                        className={"div-provider-item relative !bg-white"}
                        style={{
                           background: `url(${item?.logo_url}) center center / contain no-repeat`,
                           backgroundSize: "cover",
                           //  @ts-ignore
                           cursor: !searchState[`loading_provider_${item.code}`]
                              ? "pointer"
                              : "no-drop",
                        }}
                     >
                        {(item?.total > 0 ||
                           // @ts-ignore
                           searchState[`total_images_${item.code}`] > 0) && (
                              <div
                                 className="div-total absolute bottom-0 div-one-center"
                                 style={{
                                    cursor:
                                       //  @ts-ignore
                                       !searchState[`loading_provider_${item.code}`]
                                          ? "pointer"
                                          : "no-drop",
                                 }}
                              >
                                 {/* @ts-ignore */}
                                 {searchState[`total_images_${item.code}`] ?? item?.total}
                              </div>
                           )}
                     </div>
                  </div>
               </Spin>
            </Tooltip>
         );
      });

      return a;
   };

   const [loadingViewInfo, setLoadingViewInfo] = useState(false);

   const handleViewInfo = (item?: any) =>
   {
      setLoadingViewInfo(true);
      setSelectedView(item);
      toggleViewInfo();
   };

   useEffect(() =>
   {
      if (openViewInfo) setLoadingViewInfo(false);
   }, [openViewInfo]);

   const pageSize = 20;
   // How many already-loaded items are revealed. Monotonic; capped by data.length
   // when sliced. Grows by pageSize per scroll; once it passes the loaded length
   // we fetch the next BE page.
   const [count, setCount] = useState(pageSize);
   const scrollRef = useRef<HTMLDivElement>(null);

   const visibleData = useMemo(() => data.slice(0, count), [data, count]);

   // Reset the reveal window on a new search (data cleared to []) or provider switch.
   useEffect(() =>
   {
      if (data.length === 0)
      {
         setCount(pageSize);
         if (scrollRef.current) scrollRef.current.scrollTop = 0;
      }
   }, [data.length]);

   useEffect(() =>
   {
      setCount(pageSize);
      if (scrollRef.current) scrollRef.current.scrollTop = 0;
   }, [providerCode]);

   const fetchMore = () =>
   {
      // Reveal the next chunk of already-loaded items.
      setCount((c) => c + pageSize);

      // If that consumes everything loaded and BE has a next page, fetch it.
      if (count + pageSize >= data.length)
      {
         // @ts-ignore
         const loadingProvider = searchState[`loading_provider_${providerCode}`];
         // @ts-ignore
         const nextLink = searchState[`next_link_${providerCode}`];
         if (!loadingProvider && nextLink?.href)
         {
            handleScroll();
         }
      }
   };

   return (
      <div className="!bg-[var(--neutral-1000)] text-white rounded-xl w-full h-full flex flex-col overflow-hidden">
         {/* HEADER - Sticky */}
         <div className="flex justify-between items-center p-4 sticky top-0 bg-[var(--neutral-1000)] z-10">
            <h2 className="text-lg font-semibold">{t("Search result")}</h2>

            <div
               className="!bg-[var(--neutral-950)] cursor-pointer  rounded-lg border-none text-white px-3  py-2 h-8 flex gap-2 items-center"
               onClick={() =>
               {
                  // @ts-ignore
                  if (!searchState[`loading_provider_${providerCode}`])
                  {
                     setShowResultSearch(false);
                  }
               }}
               style={{
                  // @ts-ignore
                  cursor: searchState[`loading_provider_${providerCode}`]
                     ? "not-allowed"
                     : "pointer",
               }}
            >
               <CommonIcons.FilterIcon />
               {t("Filter")}
            </div>
         </div>

         {/* FILTER - Sticky */}
         <div className="flex items-center justify-between p-4 sticky h-[68px] top-[64px] bg-[var(--neutral-1000)] z-10">
            <Checkbox
               // @ts-ignore
               disabled={searchState[`loading_provider_${providerCode}`]}
               onChange={(e) =>
               {
                  if (e.target.checked)
                  {
                     setSelectedImages(data);
                  } else
                  {
                     setSelectedImages([]);
                  }
               }}
               className="text-white"
               checked={selectedImages.length === data.length && data.length > 0}
               indeterminate={
                  selectedImages.length > 0 && selectedImages.length < data.length
               }
            >
               {t("All")}
            </Checkbox>
            {selectedImages?.length > 0 && (
               <div className="flex items-center gap-2 text-sm text-gray-400">
                  <span>
                     {selectedImages.length} {t("Images Selected")}
                  </span>
                  <Tooltip
                     title={
                        isAllImageShown
                           ? t("Hide image on map")
                           : t("Show image on map")
                     }
                  >
                     <Button
                        // @ts-ignore
                        disabled={searchState[`loading_provider_${providerCode}`]}
                        className={`btn-action ${isAllImageShown ? "!bg-[#4CC2FF] !text-black" : ""}`}
                        icon={<CommonIcons.MapIcon />}
                        onClick={() =>
                        {
                           selectedImages.forEach((img: any) =>
                           {
                              const imageLayerId = `image-${img?.id}`;

                              if (isAllImageShown)
                              {
                                 removeImageFromMap(img, dispatch);
                              } else if (!layerIds.has(imageLayerId))
                              {
                                 showImageOnMap(img, dispatch, providerCode, mapInstance, true);
                              }
                           });

                           if (!isAllImageShown)
                           {
                              flyToGeometries(
                                 selectedImages.map((img: any) => img?.geometry),
                                 mapInstance,
                              );
                           }
                        }}
                     />
                  </Tooltip>
                  <Tooltip
                     title={
                        isAllFootprintShown
                           ? t("Hide footprint's image on map")
                           : t("Show footprint's image on map")
                     }
                  >
                     <Button
                        // @ts-ignore
                        disabled={searchState[`loading_provider_${providerCode}`]}
                        className={`btn-action ${isAllFootprintShown ? "!bg-[#4CC2FF] !text-black" : ""}`}
                        icon={<CommonIcons.FootIcon />}
                        onClick={() =>
                        {
                           selectedImages.forEach((img: any) =>
                           {
                              const footprintLayerId = `footerprint-${img?.id}`;

                              if (isAllFootprintShown)
                              {
                                 removeFootprint(img, dispatch);
                              } else if (!layerIds.has(footprintLayerId))
                              {
                                 showFootprint(img, dispatch, mapInstance, true);
                              }
                           });

                           if (!isAllFootprintShown)
                           {
                              flyToGeometries(
                                 selectedImages.map((img: any) => img?.geometry),
                                 mapInstance,
                              );
                           }
                        }}
                     />
                  </Tooltip>

                  <Tooltip
                     title={isAllInCart ? t("Remove from cart") : t("Add to cart")}
                  >
                     <Button
                        // @ts-ignore
                        disabled={searchState[`loading_provider_${providerCode}`]}
                        className={`btn-action ${isAllInCart ? "!bg-[#4CC2FF] !text-black" : ""}`}
                        icon={<CommonIcons.CartOutlinedIcon />}
                        onClick={() =>
                        {
                           const ids = selectedImages.map((img: any) => img?.id);

                           if (isAllInCart)
                           {
                              removeImagesFromCart(
                                 ids,
                                 dispatch,
                                 providerCode,
                                 idsImageInCart,
                                 t,
                              );
                           } else
                           {
                              const idsToAdd = ids.filter(
                                 (id: any) => !idsImageInCart.includes(id),
                              );

                              if (idsToAdd.length)
                              {
                                 addImagesToCart(
                                    idsToAdd,
                                    dispatch,
                                    providerCode,
                                    idsImageInCart,
                                    t,
                                 );
                              }
                           }
                        }}
                     />
                  </Tooltip>
               </div>
            )}
         </div>

         {/* PROVIDER LIST + LIST CONTAINER - Flex Row */}
         <div className="flex px-3 gap-3 flex-1 overflow-hidden">
            {/* PROVIDER LIST - 68px width, vertical */}
            <div className="w-[80px] overflow-y-auto pb-2 flex flex-col gap-3 h-fit">
               <div className="child !flex-col !w-[68px] gap-3">
                  {renderProvider()}
               </div>
            </div>

            {/* LIST - Full remaining width, scrollable */}

            <div className="w-full">
               <Spin
                  className="flex-1 !w-full"
                  // @ts-ignore
                  spinning={searchState[`loading_provider_${providerCode}`]}
               >
                  <div
                     id="explore-result-scroll"
                     ref={scrollRef}
                     className="h-full overflow-y-auto pb-4 w-full"
                  >
                     <div className="flex flex-col gap-4">
                        {data?.length === 0 &&
                           /* @ts-ignore */
                           !searchState[`loading_provider_${providerCode}`] && (
                              <NoData fontText={"18px"} />
                           )}
                        <InfiniteScroll
                           dataLength={visibleData.length}
                           next={fetchMore}
                           scrollableTarget="explore-result-scroll"
                           hasMore={
                              visibleData.length < data.length ||
                              // @ts-ignore
                              !!searchState[`next_link_${providerCode}`]?.href
                           }
                           loader={<div style={{ textAlign: "center", padding: "16px" }}>
                              <Spin />
                           </div>}

                        >
                           {visibleData?.length > 0 &&
                              visibleData.map((item: any, ind: number) => (
                                 <>
                                    <CardSearchResult
                                       item={item}
                                       handleViewInfo={handleViewInfo}
                                       providerName={providerName}
                                       selectedImages={selectedImages}
                                       setSelectedImages={setSelectedImages}
                                       providerId={providerId}
                                       handleShowFootPrint={(item: ImageItem) =>
                                          showFootprint(item, dispatch, mapInstance)
                                       }
                                       handleMouseLeaveItem={(item: ImageItem) =>
                                          mouseLeaveItem(item, engine)
                                       }
                                       handleMouseMoveItem={(item: ImageItem) =>
                                          mouseMoveItem(item, engine)
                                       }
                                       handleRemoveFootPrint={(item: ImageItem) =>
                                          removeFootprint(item, dispatch)
                                       }
                                       panTo={(item: ImageItem) =>
                                          flyToGeometry(item?.geometry, mapInstance)
                                       }
                                       handleAddCart={(ids: string[]) =>
                                          addImagesToCart(ids, dispatch, providerCode, idsImageInCart, t)
                                       }
                                       handleRemoveFromCart={(ids: string[]) =>
                                          removeImagesFromCart(ids, dispatch, providerCode, idsImageInCart, t)
                                       }
                                       handleShowImageOnMap={(item: ImageItem) =>
                                          showImageOnMap(item, dispatch, providerCode, mapInstance)
                                       }
                                       handleRemoveImage={(item: ImageItem) =>
                                          removeImageFromMap(item, dispatch)
                                       }
                                    />
                                 </>
                              ))}
                        </InfiniteScroll>
                     </div>
                  </div>
               </Spin>
            </div>
         </div>

         {shouldRenderViewInfo && (
            <CommonComponents.ModalUI
               open={openViewInfo}
               title={t("Information")}
               toggle={() =>
               {
                  toggleViewInfo();
               }}
               handleConfirm={() => { }}
               hiddenFooter={true}
               width={1120}
            >
               <Spin spinning={loadingViewInfo}>
                  <ImageInfo data={selectedView} open={openViewInfo} />
               </Spin>
            </CommonComponents.ModalUI>
         )}
      </div>
   );
}
